<template>
  <BaseDialogForm
    v-model="showStorageTypeForm"
    :title="
      editMode
        ? `Edit ${configurationModule.storageType}`
        : `Add ${configurationModule.storageType}`
    "
    :nonFieldErrors="formErrors.non_field_errors"
    :persistent="true"
    :maxWidth="800"
    :editMode="false"
  >
    <template #content>
      <v-form
        v-model="isValid"
        ref="storageTypeForm"
        :key="formCount"
        @submit.prevent="submitForm"
      >
        <v-row class="ma-0">
          <v-col cols="12">
            <InputField
              id="name"
              v-model="storageTypeDetails.name"
              unset
              :label="`Name`"
              name="name"
              :required="true"
              :error-messages="formErrors.name"
              @input="delete formErrors.name"
            />
          </v-col>
          <v-col cols="6">
            <SelectField
              name="compatible-storage_type"
              v-model="storageTypeDetails.compatible_storage_type"
              :itemsList="allStorageTypeSelectList"
              itemText="name"
              itemValue="id"
              label="Select Compatible Storage Type"
              :hideSelectAll="false"
              :multiple="true"
              :error-messages="formErrors.compatible_storage_type"
              @input="delete formErrors.compatible_storage_type"
            />
          </v-col>
          <v-col cols="6" lg="6" class="d-flex align-center">
            <SwitchField
              id="active"
              v-model="storageTypeDetails.active"
              inset
              name="active"
              hide-details
              label="Active"
              :error-messages="formErrors.active"
              @input="delete formErrors.active"
            ></SwitchField>
          </v-col>
          <v-col cols="12" lg="12" class="d-flex align-center">
            <ColorPicker
              id="color"
              label="Storage Type Color:"
              v-model="storageTypeDetails.color_code"
              hide-canvas
              hide-inputs
              ref="color_code"
            />
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template #actions>
      <SecondaryButton
        id="storageTypeFormReset"
        v-if="!editMode"
        @click="resetForm()"
        btnClass="mr-2 text-uppercase rounded-lg"
        name="Reset"
      >
      </SecondaryButton>
      <PrimaryButton
        id="storageTypeFormSubmit"
        @click="submitForm()"
        :disabled="!isValid"
        btnClass="text-uppercase rounded-lg"
        name="submit"
      >
      </PrimaryButton>
    </template>
  </BaseDialogForm>
</template>

<script>
import BaseDialogForm from "@/components/LayoutComponents/BaseDialogForm.vue";
import { configurationModule } from "@/utils/moduleMapping";
import { bus } from "@/main";

export default {
  components: {
    BaseDialogForm,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    editMode: {
      type: Boolean,
      required: true,
    },
    itemID: {
      type: Number,
    },
  },

  data() {
    return {
      configurationModule,
      formErrors: {},
      formCount: 0,
      isValid: true,
      storageTypeDetails: {
        active: true,
      },
      allStorageTypeSelectList: [],
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.getStorageTypeSelectList();
        if (this.editMode && this.itemID) {
          this.getStorageTypeObject(this.itemID);
        }
      } else {
        this.formErrors = {};
        this.resetForm();
      }
    },
  },
  computed: {
    showStorageTypeForm: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    resetForm() {
      this.storageTypeDetails = {
        active: true,
      };
      this.$refs.color_code.resetColor();
      this.$refs.storageTypeForm.reset();
    },
    getStorageTypeSelectList(params) {
      bus.$emit("showLoader", true);
      params = { limit: "all", exclude_ids: this.itemID };
      this.$api.storageType
        .getStorageTypeSelectList(params)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.allStorageTypeSelectList = res.data;
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    getStorageTypeObject(id) {
      this.$api.storageType
        .getStorageTypeObject(id)
        .then((res) => {
          this.storageTypeDetails = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    submitForm() {
      if (!this.$refs.storageTypeForm.validate()) {
        bus.$emit("showToastMessage", {
          message: "Please correct all the errors to submit the form!",
          color: "error",
        });
        return;
      }
      if (this.editMode) {
        this.$api.storageType
          .updateStorageTypeObject({
            id: this.storageTypeDetails.id,
            data: this.storageTypeDetails,
          })
          .then(() => {
            this.$emit("refreshList");
            bus.$emit("showToastMessage", {
              message: "Storage Type information updated!",
              color: "success",
            });
            this.showStorageTypeForm = false;
          })
          .catch((err) => {
            console.log(err);
            this.formErrors = err?.data || {};
          });
      } else {
        this.$api.storageType
          .createStorageTypeObject(this.storageTypeDetails)
          .then(() => {
            this.$emit("refreshList");
            bus.$emit("showToastMessage", {
              message: "Storage Type created!",
              color: "success",
            });
            this.showStorageTypeForm = false;
          })
          .catch((err) => {
            console.log(err);
            this.formErrors = err?.data || {};
          });
      }
    },
  },
};
</script>
